// Keep auth cleanup independent of native plugin loading and API construction.
let signOut;
export function setNotificationSignOut(handler) {
    signOut = handler;
}
export function prepareNotificationSignOut() {
    return signOut?.() || Promise.resolve({});
}
